// The section can appear more than once, so this file can execute twice on one
// page. The marker keeps a single delegated listener.
if (!document.documentElement.dataset.treatmentFaqBound) {
  document.documentElement.dataset.treatmentFaqBound = 'true';

  // Delegated so questions inserted by a section morph work without re-initialising.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-treatment-faq-load-more]');
    if (!button) return;

    const section = button.closest('.salon-treatment-faq');
    const hiddenQuestions = section?.querySelectorAll('[data-treatment-question][hidden]') ?? [];

    for (const question of hiddenQuestions) {
      question.removeAttribute('hidden');
    }

    button.setAttribute('hidden', '');
  });
}
